module.exports = __webpack_public_path__ + "img/img6.b57cc335.svg";